module.exports = __webpack_public_path__ + "static/img/usercenter_title_bg.7338fdff.png";